export default "__VITE_ASSET__CURzccgj__"